export default {
  devtools_already_initiated:
    "@:support.devtools have already been initiated. Restart the app to retry.",
  devtools_instructions: "Enter endpoint parameters to initiate a connection.",
  devtools_terms:
    "<p>If you connect to the development tools, you will be exposing your app data.</p>" +
    "<p>Please ensure that you are on a trusted network, and that you trust the endpoint you are connecting to.</p>" +
    "<p>Should you wish to disconnect the connection, open the @:support.devtools menu again.</p>",
  host: "host",
  invalid_input: "Invalid input.",
  port: "port",
  prompt_sure: "Are you sure?",
  title_devtools: "Connect to @:support.devtools.",
}
